import { SpaceBetween } from "@cloudscape-design/components-themed";
import { FormBlock } from "./Forms";
import { formatDateHyphen } from "../../utils/format";
import { getDivisionDict } from "../default-constants";

export const HelpPanel = (props: any) => {
  if (props.commercialData) {
    return (
      <SpaceBetween direction="vertical" size="l">
        <FormBlock
          applicationStartDate={formatDateHyphen(
            props.commercialData.applicationStartDate
          )}
          ruleNo={props.commercialData.ruleNo}
          beforeConversion={props.commercialData.conversionFromIndustryName}
          afterConversion={getDivisionDict(
            props.afterConversionFormItems,
            props.commercialData.conversionAfterIndustryCode
          )}
          readOnly={true}
        />
      </SpaceBetween>
    );
  } else {
    return <></>;
  }
};
